<template>
  <div class="hasData">
    <p class="tabtitle">投保地块信息</p>
    <el-table
      v-loading="loading"
      :data="rowInfoList"
      :header-cell-style="thClass"
      :cell-style="{ color: '#666666' }"
    >
      <el-table-column label="投保地块编码" width="350px">
        <template slot-scope="scope">
          <span>{{ scope.row.shGisDkId }}</span>
        </template>
      </el-table-column>

      <el-table-column label="投保地块名称" width="260px">
        <template slot-scope="scope">
          <span>{{ scope.row.landName ? scope.row.landName : "--" }} </span>
        </template>
      </el-table-column>
      <el-table-column label="地块面积">
        <template slot-scope="scope">
          <span>{{ scope.row.landArea ? scope.row.landArea : "--" }}亩 </span>
        </template>
      </el-table-column>
      <el-table-column label="保费">
        <template slot-scope="scope">
          <span>{{ scope.row.premium ? scope.row.premium : "--" }}元 </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="地块状态" width="122px">
        <template slot-scope="scope">
          <span>{{  }} </span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="操作"> </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  name: "tableListNo",

  created() {},
  props: {
    rowInfoList: {
      type: [Object, Array],
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },

  methods: {
    thClass() {
      return "background:#EEFFF9;color:#64C3A4;font-size:18px;";
    },
  },
};
</script>

<style lang="scss" scoped>
//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 80px;
}

.tabtitle {
  font-weight: 700;
  color: #333;
  font-size: 18px;
  margin-bottom: 30px;
  text-align: center;
}
</style>
